<template>
  <div>
    <div id="section1">
      <v-layout row wrap>
        <!-- left -->
        <v-flex xs12 class="layout-left">
          <div class="hidden-600px">
            <h1 class="font-md">{{ $t("section1.title_service") }}</h1>
            <div class="font-sm layout-service">
              <div style="position: relative">
                <img
                  src="@/assets/font/landingPage/Group1.png"
                  alt="fooddelivery"
                  class="img-service"
                />
                <span
                  style="position: absolute; top: 10px; margin-left: 30px"
                  >{{ $t("section1.service_food") }}</span
                >
              </div>
              <div style="position: relative">
                <img
                  src="@/assets/font/landingPage/Group2.png"
                  alt="fooddelivery"
                  class="img-service"
                />
                <span
                  style="position: absolute; top: 10px; margin-left: 30px"
                  >{{ $t("section1.service_mess1") }}</span
                >
              </div>
              <div style="position: relative">
                <img
                  src="@/assets/font/landingPage/Group3.png"
                  alt="fooddelivery"
                  class="img-service"
                />
                <span
                  style="position: absolute; top: 10px; margin-left: 30px"
                  >{{ $t("section1.service_mess2") }}</span
                >
              </div>
            </div>
            <div class="title-download">
              {{ $t("section1.download1") }}
              <br />
              {{ $t("section1.download2") }}
            </div>
            <div class="flex-container" style="display: flex">
              <a
                href="https://apps.apple.com/th/app/weserve/id1464895492?l=th#?platform=iphone"
                target="_blank"
                style="text-decoration: none"
              >
                <div class="btn-apple elevation-3">
                  <v-layout row justify-center>
                    <v-flex xs4 class="text-xs-center">
                      <img
                        src="@/assets/font/apple_logo.png"
                        alt="apple"
                        class="logo-apple"
                      />
                    </v-flex>
                    <v-flex xs8>
                      <span>Download on the</span>
                      <div class="font-apple">App Store</div>
                    </v-flex>
                  </v-layout>
                </div>
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=v4.weserve.application"
                target="_blank"
                style="text-decoration: none"
              >
                <div class="btn-google elevation-3">
                  <v-layout row justify-center>
                    <v-flex xs4 class="text-xs-center">
                      <img
                        src="@/assets/font/google-play.png"
                        alt="apple"
                        class="logo-google"
                      />
                    </v-flex>
                    <v-flex xs8>
                      <span>Download on the</span>
                      <div class="font-google">Google Play</div>
                    </v-flex>
                  </v-layout>
                </div>
              </a>
            </div>
          </div>
          <div class="hidden-600px-up">
            <!-- imgTop -->
            <img :src="imgTop($i18n.locale)" alt="weserve" width="100%" />
            <div class="title-download">
              {{ $t("section1.download1") }}
              <br />
              {{ $t("section1.download2") }}
            </div>
            <a
              href="https://apps.apple.com/th/app/weserve/id1464895492?l=th#?platform=iphone"
              target="_blank"
              style="text-decoration: none"
            >
              <img
                src="@/assets/font/landingPage/app_store.png"
                alt="weserve_app_store"
                class="btn-xs-download"
              />
            </a>
            <br />
            <a
              href="https://play.google.com/store/apps/details?id=v4.weserve.application"
              target="_blank"
              style="text-decoration: none"
            >
              <img
                src="@/assets/font/landingPage/google_play.png"
                alt="weserve_google_play"
                class="btn-xs-download"
              />
            </a>
          </div>
          <div class="mt-4 position-btn-web">
            <!-- <span class="font-xs">{{$t('section1.title_web1')}}&nbsp;</span>
            <span class="font-xs" style="font-weight:700;">{{$t('section1.title_web2')}}</span>
            <br>
            <v-btn
              outline
              style="border-radius:5px;"
              :href="'https://phuket.weserve.co.th/' + $i18n.locale + '/'"
              target="_blank"
            >{{$t('section1.phuket')}}</v-btn>
            <v-btn
              outline
              style="border-radius:5px;"
              :href="'https://trang.weserve.co.th/' + $i18n.locale + '/'"
              target="_blank"
            >{{$t('section1.trang')}}</v-btn>-->
          </div>
        </v-flex>
        <!-- right -->
        <div class="circle-right">
          <div class="big-circle">
            <div class="small-circle"></div>
            <div class="mini-circle"></div>
          </div>
          <v-flex xs12 class="d-flex layout-right">
            <div class="text-xs-center">
              <span class="font-xl">{{ $t("section1.now_open") }}</span>
              <v-layout>
                <v-flex xs6>
                  <v-layout column class="font-sm mt-3 dt-pin">
                    <v-flex
                      class="my-1"
                      v-for="(item, index) in items_province"
                      :key="index"
                    >
                      <v-icon color="black" class="mr-2" size="40">{{
                        item.icon
                      }}</v-icon>
                      {{ item.title }}
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6>
                  <v-img
                    v-if="$i18n.locale == 'th'"
                    :src="img_mobile_th"
                    alt="weserve_app"
                    contain
                    width="270px"
                  />
                  <v-img
                  v-else
                    :src="img_mobile_en"
                    alt="weserve_app"
                    contain
                    width="270px"
                  />
                </v-flex>
              </v-layout>
              <!-- <v-layout column class="font-sm mt-3 dt-pin">
                <v-flex
                  class="my-1"
                  v-for="(item, index) in items_province"
                  :key="index"
                >
                  <v-icon color="black" class="mr-2" size="40">{{
                    item.icon
                  }}</v-icon>
                  {{ item.title }}
                </v-flex>

                <v-img
                  :src="img_mobile"
                  alt="weserve_app"
                  aspect-ratio="1"
                  contain
                  class="img-mobile"
                />
              </v-layout> -->

              <!-- <div class="mb-pin">
                <v-layout row wrap>
                  <v-flex xs12 style="position:absolute;left:-50px;margin-top:20px;">
                    <div class="text-xs-left" v-for="(item, index) in items_province" :key="index">
                      <v-icon color="black" class="mr-2" size="40">{{item.icon}}</v-icon>
                      {{item.title}}
                    </div>
                  </v-flex>
                  <v-flex xs12 style="position:absolute;left:30px;margin-top:20px;">
                    <v-img
                      :src="img_mobile"
                      alt="weserve_app"
                      aspect-ratio="1"
                      contain
                      class="img-mobile"
                    />
                  </v-flex>
                </v-layout>
              </div>-->
            </div>
          </v-flex>
        </div>
      </v-layout>
    </div>

    <div height="auto" id="section2">
      <v-layout row wrap align-center>
        <v-flex xs12 md6 order-xs2 order-md1 class="layout-left2">
          <v-img
            class="img-youneed"
            :src="img_youneed"
            alt="weserve_service"
            aspect-ratio="1"
            contain
          />
          <!-- <div class="three-dot"></div>ให้เราจัดการส่งของทุกอย่าง
          <br>
          <span style="font-size:24px;">ที่คุณต้องการ</span>-->
        </v-flex>
        <v-flex xs12 md6 order-xs1 order-md2 class="layout-right2">
          <div class="text-xs-center">
            <span class="font-xl">{{ $t("section2.title1") }}&nbsp;</span>
            <span class="font-xl" style="color: #ffd604">WESERVE</span>
            <div class="font-md text-xs-right">{{ $t("section2.title2") }}</div>
          </div>

          <div class="layout-card-service">
            <v-card
              flat
              class="card-service"
              v-for="(item, index) in items_services"
              :key="index"
            >
              <v-layout row wrap align-center>
                <v-flex xs6 sm2 class="text-xs-center">
                  <img :src="item.icon" alt="weserve" class="icon-service" />
                </v-flex>
                <v-flex xs6 sm4>
                  <div class="title-service">{{ item.title }}</div>
                </v-flex>
                <v-flex xs12 sm6 class="subtitle-service">{{
                  item.subtitle
                }}</v-flex>
              </v-layout>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div height="auto" id="section3">
      <v-layout row wrap justify-center align-center>
        <v-flex xs12 md3 class="logo-howto">
          <img
            src="@/assets/font/landingPage/logo-apple-watch.png"
            alt="logo_weserve"
            width="120px"
          />
        </v-flex>
        <v-flex xs12 md5 class="font-xl title-howto">{{
          $t("section3.title")
        }}</v-flex>
        <img
          class="section3-img hidden-xs-only"
          :src="imgHow($i18n.locale)"
          alt="weserve"
          width="100%"
        />
      </v-layout>
      <div class="hidden-sm-and-up">
        <img
          class="section3-img"
          :src="imgFood($i18n.locale)"
          alt="weserve"
          width="100%"
        />
        <img
          class="section3-img"
          :src="imgMess($i18n.locale)"
          alt="weserve"
          width="100%"
        />
      </div>
    </div>

    <transition name="back-to-top-fade">
      <v-fab-transition>
        <v-btn
          light
          fab
          fixed
          bottom
          right
          color="primary"
          @click="backToTop()"
          v-show="visible"
        >
          <v-icon color="black">keyboard_arrow_up</v-icon>
        </v-btn>
      </v-fab-transition>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img_mobile_th: require("@/assets/font/landingPage/mobile-img-th.png"),
      img_mobile_en: require("@/assets/font/landingPage/mobile-img-en.png"),
      img_youneed: require("@/assets/font/landingPage/service1.png"),
      img_logo_howto: require("@/assets/font/landingPage/logo-apple-watch.png"),
      img_krabi: require("@/assets/font/landingPage/krabi_th.png"),
      icon1: require("@/assets/font/landingPage/serve.png"),
      icon2: require("@/assets/font/landingPage/motorcycle.png"),
      icon3: require("@/assets/font/landingPage/paper_bag.png"),
      icon4: require("@/assets/font/landingPage/bill.png"),
      icon5: require("@/assets/font/landingPage/truck.png"),
      visibleoffset: 20,
      visible: false,
    };
  },
  computed: {
    items_province() {
      return [
        {
          icon: "place",
          title: this.$t("section1.trang"),
        },
        {
          icon: "place",
          title: this.$t("section1.phuket"),
        },
        {
          icon: "place",
          title: this.$t("section1.krabi"),
        },
        {
          icon: "place",
          title: this.$t("section1.songkhla"),
        },
        {
          icon: "place",
          title: this.$t("section1.surat"),
        },
        {
          icon: "place",
          title: this.$t("section1.prachuap"),
        },
        {
          icon: "place",
          title: this.$t("section1.phattalung"),
        },
        {
          icon: "place",
          title: this.$t("section1.nakhon"),
        },
        {
          icon: "place",
          title: this.$t("section1.yala"),
        },
      ];
    },
    items_services() {
      return [
        {
          icon: require("@/assets/font/landingPage/serve.png"),
          title: this.$t("section2.card1"),
          subtitle: this.$t("section2.sub_card1"),
        },
        {
          icon: require("@/assets/font/landingPage/motorcycle.png"),
          title: this.$t("section2.card2"),
          subtitle: this.$t("section2.sub_card2"),
        },
        {
          icon: require("@/assets/font/landingPage/paper_bag.png"),
          title: this.$t("section2.card3"),
          subtitle: this.$t("section2.sub_card3"),
        },
        {
          icon: require("@/assets/font/landingPage/bill.png"),
          title: this.$t("section2.card4"),
          subtitle: this.$t("section2.sub_card4"),
        },
        {
          icon: require("@/assets/font/landingPage/truck.png"),
          title: this.$t("section2.card5"),
          subtitle: this.$t("section2.sub_card5"),
        },
      ];
    },
  },

  methods: {
    imgHow(lang) {
      if (lang == "en") {
        return require("@/assets/font/landingPage/how_it_work_en.png");
      } else if (lang == "th") {
        return require("@/assets/font/landingPage/how_it_work_th.png");
      }
    },
    imgFood(lang) {
      if (lang == "en") {
        return require("@/assets/font/landingPage/app_food_text.png");
      } else if (lang == "th") {
        return require("@/assets/font/landingPage/app_food_text_th.png");
      }
    },
    imgMess(lang) {
      if (lang == "en") {
        return require("@/assets/font/landingPage/app_messenger_text.png");
      } else if (lang == "th") {
        return require("@/assets/font/landingPage/app_messenger_text_th.png");
      }
    },
    imgTop(lang) {
      if (lang == "en") {
        return require("@/assets/font/landingPage/landing_en.jpg");
      } else if (lang == "th") {
        return require("@/assets/font/landingPage/landing_th.jpg");
      }
    },
    toLogin() {
      this.$router.push({ path: "/weserve_admin_login" });
    },
    toLandingPos() {
      this.$router.push({ path: "/landing_pos" });
    },
    /**
     @return {void}
        */
    catchScroll() {
      this.visible = window.pageYOffset > parseInt(this.visibleoffset);
    },
    /**
     @return {void}
        */
    backToTop() {
      window.smoothscroll();
    },
  },
  mounted() {
    window.smoothscroll = () => {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.addEventListener("scroll", this.catchScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.catchScroll);
  },
};
</script>

<style scoped>
/* Start Fon */
#section1 {
  display: flex;
  /* height: 100vh; */
  position: relative;
  top: 0;
}
.circle-right {
  position: absolute;
  display: flex;
  right: 1%;
  width: 61rem;
  height: 61rem;
  top: -23%;
}
.mb-pin {
  display: none;
}
/* End Fon */
.font-xs {
  text-align: left;
  font-size: 15px;
  color: #a8a8a8;
  font-family: "Kanit-Regular";
}
.font-sm {
  text-align: left;
  font-size: 20px;
  color: #000000;
  font-family: "Kanit-Regular", "SukhumvitSet-Medium";
}
.font-md {
  font-size: 28px;
  color: #a8a8a8;
  opacity: 1;
  font-weight: 300;
  font-family: "Kanit-Regular", "SukhumvitSet-Medium";
}
.font-xl {
  font-size: 45px;
  color: #000000;
  opacity: 1;
  font-weight: 300;
  font-family: "Kanit-Regular", "SukhumvitSet-Medium";
}
/* section1 */
.section1-layout {
  padding: 0px 80px 20px 80px;
  position: relative;
}
.layout-left {
  margin-top: 5%;
  padding-left: 8%;
}
.layout-right {
  z-index: 1;
  padding: 12% 15% 18% 30%;
}
.layout-service {
  margin: 20px 0 50px 50px;
}
.img-service {
  width: 50px;
  height: 50px;
}
.title-download {
  font-size: 20px;
  letter-spacing: 2px;
  color: #a8a8a8;
}
.position-btn-web {
  padding: 10px 0 30px 0;
}
.img-mobile {
  width: 36rem;
  position: absolute;
  top: 25%;
  right: -15px;
}
.big-circle {
  width: 90%;
  height: 90%;
  border-radius: 50%;
  background-color: #ffd604;
  -webkit-box-shadow: -10px 10px 30px #bababa8e;
  box-shadow: -10px 10px 30px #bababa8e;
  position: absolute;
  right: 0;
  top: 0;
  padding: 0 10%;
}
.small-circle {
  width: 13rem;
  height: 13rem;
  border-radius: 50%;
  background: #fdf1b5;
  opacity: 0.73;
  position: absolute;
  z-index: 1;
  top: 250px;
  left: -100px;
}
.mini-circle {
  width: 7rem;
  height: 7rem;
  border-radius: 50%;
  background: #fdf1b5;
  opacity: 0.73;
  position: absolute;
  z-index: 1;
  top: 490px;
  left: -20px;
}
.btn-apple {
  background-color: black;
  width: 230px;
  padding: 7px 0 3px 0;
  border-radius: 6px;
  margin: 10px;
}
.btn-apple:hover {
  background-color: #333;
}
.btn-apple span {
  color: white;
}
.font-apple {
  color: white;
  font-size: 25px;
}
.logo-apple {
  height: 40px;
  margin-top: 8px;
}
.btn-google {
  background-color: black;
  width: 230px;
  padding: 7px 0 3px 0;
  border-radius: 6px;
  margin: 10px;
}
.btn-google:hover {
  background-color: #333;
}
.btn-google span {
  color: white;
}
.font-google {
  color: white;
  font-size: 25px;
}
.logo-google {
  height: 35px;
  margin-top: 10px;
}
.hidden-600px-up {
  display: none;
}
.footer {
  background-color: #ffdd00;
  padding: 10px 0 3px 0;
  display: flex;
  justify-content: center;
}
.btn-footer {
  height: 60px;
}
/* section2 */
#section2 {
  padding: 70px 0 100px 0;
}
.layout-left2 {
  text-align: center;
}
.layout-right2 {
  padding: 0 120px 0 0;
}
.img-youneed {
  height: 450px;
}
.layout-card-service {
  margin: 30px 0;
}
.card-service {
  margin: 10px 0;
  padding: 15px 30px;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
  opacity: 1;
}
.card-service:hover {
  background-color: #ffd604;
}
.icon-service {
  height: 30px;
}
.title-service {
  font-size: 16px;
  font-weight: 300;
  font-family: "Kanit-Regular";
}
.subtitle-service {
  font-family: "Kanit-Regular";
}

/* section3 */
#section3 {
  /* text-align: center; */
  background-color: #ededed;
  padding: 50px 40px 30px 40px;
}
.logo-howto {
  text-align: right;
}
.title-howto {
  padding-left: 30px;
}

/* small section1 */
.section1-small-layout {
  padding: 170px 0 20px 0;
  position: relative;
  display: none;
}
.layout-download {
  padding: 30px 0 3px 0;
  display: flex;
  justify-content: center;
}
.btn-download {
  height: 50px;
}

@media screen and (max-width: 1440px) {
  .circle-right {
    right: -5%;
  }
  .big-circle {
    width: 80%;
    height: 80%;
  }
}

@media screen and (max-width: 1264px) {
  .title-download {
    font-size: 20px;
    font-weight: 900;
    padding: 30px 0 0 20px;
  }
  .flex-container {
    margin-top: 0;
  }
  .font-apple {
    font-size: 20px;
  }
  .font-google {
    font-size: 20px;
  }

  .btn-footer {
    height: 40px;
  }
}

@media screen and (max-width: 1024px) {
  .circle-right {
    right: 0%;
  }
  .big-circle {
    width: 77%;
    height: 77%;
    top: 5%;
    right: 2%;
  }
  .layout-right {
    /* padding: 27% 43% 19% 12%; */
    padding-top: 26%;
    right: 0;
  }
  .img-mobile {
    width: 32rem;
    top: 37%;
    right: 1%;
  }
  .mini-circle {
    width: 7rem;
    height: 7rem;
    top: 490px;
    left: -20px;
  }
  .layout-left {
    margin-top: 34%;
    padding-left: 3%;
    text-align: center;
    width: 100%;
  }
  .layout-left h1 {
    display: none;
  }
  .flex-container {
    align-items: center;
    justify-content: center;
  }
  .logo-howto {
    text-align: center;
    /* margin-top: -28%;
    position: absolute; */
  }
  #section3 {
    padding: 60px 40px 30px 40px;
  }
}

@media screen and (max-width: 960px) {
  .layout-right2 {
    padding: 0 40px;
  }
  .title-download {
    text-align: center;
  }
  .layout-service {
    margin: 7px 0 50px 90px;
    padding-left: 10%;
  }
  .circle-right {
    right: -76px;
    width: 110%;
    height: 82%;
    top: -18%;
  }
  .big-circle {
    width: 100%;
    top: -27%;
    height: 100%;
  }
  .small-circle,
  .mini-circle {
    display: none;
  }

  .layout-right {
    padding: 17% 23% 20% 23%;
  }
  .img-mobile {
    width: 36rem;
    top: 35%;
    right: 13%;
  }
  .layout-left {
    margin-top: 56%;
  }
  .title-howto {
    padding: 30px;
    text-align: center;
    font-size: 3em;
  }
  .logo-howto {
    /* margin-top: -33%; */
  }
}
@media screen and (max-width: 768px) {
  .layout-right2 {
    padding: 0 40px;
  }
  .title-download {
    text-align: center;
  }
  .layout-service {
    margin: 100px 0 50px 50px;
    padding-left: 10%;
  }
  .circle-right {
    right: -76px;
    width: 110%;
    height: 82%;
    top: -18%;
  }
  .big-circle {
    width: 100%;
    top: -27%;
    height: 100%;
  }
  .small-circle,
  .mini-circle {
    display: none;
  }

  .layout-right {
    padding: 20% 23% 20% 19%;
  }
  .img-mobile {
    width: 36rem;
    top: 35%;
    right: 7%;
  }
  .layout-left {
    margin-top: 56%;
  }
  .title-howto {
    padding: 30px;
    text-align: center;
    font-size: 3em;
  }
  .logo-howto {
    /* margin-top: -33%; */
  }
}
@media screen and (max-width: 600px) {
  .font-xs {
    text-align: left;
    font-size: 17px;
    color: #a8a8a8;
    font-family: "Kanit-Regular";
  }
  .font-sm {
    text-align: left;
    font-size: 20px;
    color: #000000;
    font-family: "Kanit-Regular";
  }
  .font-md {
    font-size: 23px;
    color: #a8a8a8;
    opacity: 1;
    font-weight: 300;
    font-family: "Kanit-Regular";
  }
  .font-xl {
    font-size: 35px;
    color: #000000;
    opacity: 1;
    font-weight: 300;
    font-family: "Kanit-Regular";
  }
  .big-circle {
    width: 37rem;
    height: 37rem;
    top: -110px;
    position: relative;
    left: 25%;
  }
  .small-circle {
    width: 0;
    height: 0;
  }
  .mini-circle {
    width: 0;
    height: 0;
  }
  .img-mobile {
    /* position: absolute; */
    top: 75%;
    right: auto;
    width: 30rem;
  }
  .title-download {
    text-align: center;
  }
  .layout-right {
    padding-left: 10px;
    position: absolute;
    top: 85px;
  }
  .layout-right2 {
    padding: 0 20px;
  }
  #section3 {
    padding: 50px 10px;
    position: relative;
  }
  .section3-img {
    padding: 0 30px 0 20px;
  }
  .circle-right {
    right: 0;
    width: 124%;
    height: 10%;
    top: 0;
    display: none;
  }
  .layout-left {
    margin-top: 0;
    padding-left: 0;
  }
  .layout-right {
    /* padding: 24% 5%; */
    top: -150%;
  }

  .dt-pin {
    display: none;
  }
  .mb-pin {
    display: flex;
    flex-direction: row;
  }
  .layout-service {
    display: none;
  }
  .hidden-600px {
    display: none;
  }
  .hidden-600px-up {
    display: block;
  }
  .btn-xs-download {
    width: 250px;
    margin-top: 10px;
  }
}
</style>
